import { render, staticRenderFns } from "./SupporterViewAddresses.vue?vue&type=template&id=76127d96&"
import script from "./SupporterViewAddresses.vue?vue&type=script&lang=js&"
export * from "./SupporterViewAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76127d96')) {
      api.createRecord('76127d96', component.options)
    } else {
      api.reload('76127d96', component.options)
    }
    module.hot.accept("./SupporterViewAddresses.vue?vue&type=template&id=76127d96&", function () {
      api.rerender('76127d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Details/SupporterViewAddresses.vue"
export default component.exports